import { EMPTY_FIELD } from '../constants/emptyField';
import { ChildFields, SecondParent } from '../models/child';
import { createField } from './fieldHelpers';
import { cardInitialState } from '../models/card';
import { Field } from '../declarations/widget-ums';
import { APPLICANT, CHILDREN, SPOUSE } from '../constants/modelNames';

export const initialPersonState = {
  name: EMPTY_FIELD,
  surname: EMPTY_FIELD,
  patronymic: EMPTY_FIELD,
  isPatronymicAbsent: createField(false),
  changeName: EMPTY_FIELD,
  changedSurname: EMPTY_FIELD,
  changedName: EMPTY_FIELD,
  changedPatronimic: EMPTY_FIELD,
  isChangedPatronymicAbsent: createField(false),
  changeNameDocIssuer: EMPTY_FIELD,
  birthdate: EMPTY_FIELD,
  deathdate: EMPTY_FIELD,
  birthPlace: EMPTY_FIELD,
  sex: EMPTY_FIELD,
};

export const initialSecondParentState: SecondParent = {
  ...initialPersonState,
  id: '',
  status: EMPTY_FIELD,
  proofOfDeath: EMPTY_FIELD,
  dateOfMarriage: EMPTY_FIELD,
  dateOfDivorce: EMPTY_FIELD,
  divorceDocIssuer: EMPTY_FIELD,
  deathDocIssuer: EMPTY_FIELD,
  paternityRegisterDate: EMPTY_FIELD,
  paternityRegisterNumber: EMPTY_FIELD,
  deathdate: EMPTY_FIELD,
};

export interface Organization {
  institutionName: Field<string>;
  isFoundInCatalog: boolean;
  suggestions: any[];
  error: boolean;
}

export const initialOrganizationState: Organization = {
  institutionName: EMPTY_FIELD,
  suggestions: [],
  isFoundInCatalog: true,
  error: false,
};

export const initialChildState: Partial<ChildFields> = {
  id: '',
  selectedParent: EMPTY_FIELD,
  addressMatchWithApplicant: createField(null),
  bornInCurrentMarriage: EMPTY_FIELD,
  bornInNotCurrentMarriage: EMPTY_FIELD,
  confirmingDocs: createField(''),
  secondParent: initialSecondParentState,
  showSecondParentContent: false,
  isStudying: null,
  education: initialOrganizationState,
  polyclinic: initialOrganizationState,
  cardStatus: cardInitialState,
  isRegisteredInMoscow: true,
};

export interface NamespacesReadyToSendStats {
  [APPLICANT]: boolean;
  [SPOUSE]: boolean;
  [CHILDREN]: boolean;
}

export const initialReadyNamespaces: NamespacesReadyToSendStats = {
  [APPLICANT]: true,
  [SPOUSE]: true,
  [CHILDREN]: true,
};
